// replace universal-cookie dependency with dead simple document.cookie usage
// move to Cookie Store API when it is widely supported

export const
  getCookie = name => document.cookie.split('; ').find(r => r.startsWith(name + '='))?.split('=')[1],

  removeCookie = name => { document.cookie = `${name}=; Max-Age=0; path=/` }

export default { get: getCookie, remove: removeCookie }
